import * as type from "../types";

export function getAnalyticsDataAction(payload) {
  return {
    type: type.GET_ANALYTICS_DATA,
    payload: payload,
  };
}
export function getAnalyticsDataEveningAction(payload) {
  return {
    type: type.GET_ANALYTICS_DATA_EVN,
    payload: payload,
  };
}
export function getAnalyticsCallBreakDownDataAction(payload) {
  return {
    type: type.GET_ANALYTICS_CALL_BREAK_DOWN_DATA,
    payload: payload,
  };
}

export function getAnalyticsCallOverviewAction(payload) {
  return {
    type: type.GET_ANALYTICS_CALL_OVERVIEW_DATA,
    payload: payload,
  };
}

export function getAnalyticsUnansweredDataAction(payload) {
  return {
    type: type.GET_ANALYTICS_UNANSWERED_DATA,
    payload: payload,
  };
}

export function putEditAnalyticsDataAction(payload) {
  return {
    type: type.PUT_EDIT_ANALYTICS_DATA,
    payload: payload,
  };
}
export function getAnalyticsDataActionINC(payload) {
  return {
    type: type.GET_ANALYTICS_DATA_INC,
    payload: payload,
  };
}

export function getAnalyticsCallBreakDownDataActionINC(payload) {
  return {
    type: type.GET_ANALYTICS_CALL_BREAK_DOWN_DATA_INC,
    payload: payload,
  };
}